module.exports = __webpack_public_path__ + "static/media/apartment.a6108412.webp";